import React from 'react';
import moment from 'moment';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  FilterFormStyled,
  FilterRow,
  FilterColumn,
} from '../../css/styles/filter';
import { SelectStyled } from '../../css/styles/select';
import { ErrorSharp } from '@material-ui/icons';

const handleValidate = ({ equipment, employee }) => {
  const errors = {};
  if (!equipment && !employee) {
    errors.equipment = 'OBRIGATÓRIO';
    errors.employee = 'OBRIGATÓRIO';
  }

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting }) => {
  const filters = {
    employee_uuid: values.employee?.uuid || null,
    equipment_uuid: values.equipment?.uuid || null,
  };
  console.log('Format for API ->:', filters);
  await props.onList(filters);
  setSubmitting(false);
};

const TechnicalReportFilterForm = props => {
  const { onList, equipments, employees } = props;

  return (
    <Formik
      enableReinitialize={false}
      initialValues={{
        equipment: null,
        employee: null,
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        errors,
        touched,
        dirty,
        setFieldValue,
        handleChange,
        handleBlur,
        handleReset,
        isSubmitting,
      }) => (
        <FilterFormStyled>
          <h1>FILTROS</h1>

          <ul>
            <FilterRow>
              <FilterColumn>
                <strong>EMPREGADOS:</strong>
                <Select
                  styles={SelectStyled}
                  id="employee"
                  name="employee"
                  value={values.employee}
                  placeholder="Selecione um empregado"
                  onChange={selectedOption => {
                    setFieldValue('employee', selectedOption);
                  }}
                  isSearchable
                  options={employees}
                  isLoading={false}
                  getOptionLabel={item => item.name}
                  getOptionValue={item => item.uuid}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando empregados'}
                  noOptionsMessage={() => 'Não há empregados para exibir'}
                />
                {errors.employee && touched.employee && (
                  <span>{errors.employee}</span>
                )}
              </FilterColumn>
              <FilterColumn>
                <strong>VEÍCULOS:</strong>
                <Select
                  styles={SelectStyled}
                  id="equipment"
                  value={values.equipment}
                  placeholder="Selecione um veículo"
                  onChange={selectedOption =>
                    setFieldValue('equipment', selectedOption)
                  }
                  isSearchable
                  options={equipments}
                  getOptionLabel={item => item.code}
                  getOptionValue={item => item.uuid}
                  name="equipment"
                  isLoading={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando veículos'}
                  noOptionsMessage={() => 'Não há veículos cadastrados'}
                />

                {errors.equipment && touched.equipment && (
                  <span>{errors.equipment}</span>
                )}
              </FilterColumn>
            </FilterRow>
            <FilterRow>
              <div className="buttons-container">
                <button type="submit" disabled={isSubmitting}>
                  BUSCAR
                </button>

                <button
                  type="button"
                  onClick={() => {
                    onList();
                    handleReset();
                  }}
                  disabled={isSubmitting || !dirty}
                >
                  RESET
                </button>
              </div>
            </FilterRow>
          </ul>
        </FilterFormStyled>
      )}
    </Formik>
  );
};

TechnicalReportFilterForm.propTypes = {
  equipments: PropTypes.arrayOf(PropTypes.shape(PropTypes.string)),
};

TechnicalReportFilterForm.defaultProps = {
  equipments: [],
};

export default TechnicalReportFilterForm;

